import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReserveMutexState {
  busy: boolean;
  productId: number | null;
}

const initialState: ReserveMutexState = {
  busy: false,
  productId: null,
};

const reserveMutexSlice = createSlice({
  name: "reserveMutex",
  initialState,
  reducers: {
    startReserve(state, action: PayloadAction<number>) {
      state.busy = true;
      state.productId = action.payload;
    },
    finishReserve(state) {
      state.busy = false;
      state.productId = null;
    },
  },
});

export const { startReserve, finishReserve } = reserveMutexSlice.actions;
export default reserveMutexSlice.reducer;